import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { useAuthStore } from '~/store/authStore'

declare global {
  interface Window {
    Pusher: typeof Pusher
    Echo: Echo<'pusher'>
  }
}

export default defineNuxtPlugin(() => {
  const config = useNuxtApp().$config

  const user = useAuthStore()

  window.Pusher = Pusher
  window.Echo = new Echo<'pusher'>({
    broadcaster: 'pusher',
    key: config.public.pusher.app_key,
    wsHost: config.public.pusher.host,
    wsPort: config.public.pusher.port,
    wssPort: config.public.pusher.port,
    cluster: config.public.pusher.cluster,
    forceTLS: false,
    channelAuthorization: {
      endpoint: config.public.api_base_url + '/broadcasting/auth',
      headersProvider: () => {
        if (user.getToken()) {
          return { Authorization: `Bearer ${user.getToken()}` }
        }
      },
    },
  })
})
